// Pure-CSS device frames for showcasing real Amden One screenshots.

export const BrowserFrame = ({ src, alt, url = "amden.one/app", className = "" }) => (
  <div className={`rounded-xl overflow-hidden shadow-2xl ring-1 ring-slate-200 bg-white ${className}`} data-testid="browser-frame">
    <div className="flex items-center gap-1.5 px-4 h-9 bg-slate-100 border-b border-slate-200">
      <span className="h-3 w-3 rounded-full bg-red-400" />
      <span className="h-3 w-3 rounded-full bg-amber-400" />
      <span className="h-3 w-3 rounded-full bg-emerald-400" />
      <span className="ml-3 hidden sm:flex flex-1 max-w-sm h-5 rounded-md bg-white border border-slate-200 text-[11px] text-slate-400 items-center px-3">{url}</span>
    </div>
    <img src={src} alt={alt} loading="lazy" className="w-full block" />
  </div>
);

export const TabletFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-[1.5rem] bg-slate-900 p-2.5 shadow-2xl ring-1 ring-black/10 ${className}`} data-testid="tablet-frame">
    <div className="rounded-[0.9rem] overflow-hidden bg-white aspect-[16/10]">
      <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
    </div>
  </div>
);

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-[2rem] bg-slate-900 p-2 shadow-2xl ring-1 ring-black/10 ${className}`} data-testid="phone-frame">
    <div className="rounded-[1.5rem] overflow-hidden bg-white aspect-[9/19]">
      <img src={src} alt={alt} loading="lazy" className="w-full h-full object-cover object-top" />
    </div>
  </div>
);
